const d = 'M686-450H160v-60h526L438-758l42-42 320 320-320 320-42-42 248-248Z';

export default d;
